import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { DEFAULT_LOCAL_PATH } from '../constents';
import Button from './Button';
function PatientMainSerch({ patListArr, handleAppOpen, handleClose }) {
  const navigate = useNavigate();
  const handlePatToChart = (patId, page = '') => {
    if (page === 'chart') {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/counNote/${patId}`);
    } else if (page === 'docs') {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/docs/${patId}`);
    } else if (page === 'profile') {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/profile/${patId}`);
    } else if (page === 'insurance') {
      navigate(`${DEFAULT_LOCAL_PATH}/patient/insurance/${patId}`);
    }
    handleClose();
  };
  return (
    <div className="main-contnr main-ptnt-srch-popup qhide">
      <div className="flex-sec justify-between item-center">
        <div className="hdr-pt-info">Patients</div>
        <Button variant="circle" onClick={() => handleClose()}>
          X
        </Button>
      </div>
      <div className="main-contnr-bdy">
        <ul>
          {patListArr ? (
            patListArr.map((data, idx) => {
              let altClr = idx % 2 === 0 ? 'alt-clr' : '';
              return (
                <li
                  key={idx}
                  className={`contnr-bdy-rw grid-sec lh20 ${altClr}`}
                >
                  <span className="width100 flex-sec">
                    <span className="width70 green-txt">
                      <span className="fontsize14">
                        {`${data?.patName} - ${data?.age} [${data?.gender
                          .toUpperCase()
                          .substr(0, 1)}]`}
                      </span>
                      <span className="red">{' | '}</span>
                      DOB:{data?.dob}
                      <span className="red">{' | '}</span>
                      ID: {data?.chart_number.toUpperCase()}
                    </span>
                    <span className="width30 flex-sec">
                      {data?.patstatusid === '1' ? (
                        <Link
                          className="width100"
                          onClick={() => handleAppOpen(false, data)}
                        >
                          Appointment
                        </Link>
                      ) : (
                        <span className="clear-right10">Appointment</span>
                      )}
                      <span className="red hide">{' | '}</span>
                      <Link className="width100 clear-left10 hide">Alerts</Link>
                    </span>
                  </span>
                  <span className="width100 flex-sec">
                    <span className="width70">
                      <span className="sec-colr">
                        {data?.lastVisDt || 'DOS: NA'}
                      </span>
                      <span className="red">{' | '}</span>
                      <span className="sec-colr">
                        {data?.lastVisTov || 'TOV: NA'}
                      </span>
                      <span className="red">{' | '}</span>
                      <span className="sec-colr">
                        {data?.lastAppResName || 'R: NA'}
                      </span>
                    </span>
                    <span className="width30 flex-sec">
                      <span
                        onClick={() => handlePatToChart(data?.userId, 'chart')}
                        className="width100"
                      >
                        <Link to="" className="width100">
                          Chart
                        </Link>
                      </span>

                      <span className="red">{' | '}</span>
                      <span
                        onClick={() => handlePatToChart(data?.userId, 'docs')}
                        className="width100"
                      >
                        <Link
                          className="width100 clear-left10"
                          // to={`${DEFAULT_LOCAL_PATH}/patient/docs/${data?.userId}`}
                        >
                          Documents
                        </Link>
                      </span>
                    </span>
                  </span>
                  <span className="width100 flex-sec">
                    <span className="width70">
                      <span className="sec-colr">H: {data?.home_phone}</span>
                      <span className="red">{' | '}</span>
                      <span className="sec-colr">M: {data?.mobile} </span>
                      <span className="red">{' | '}</span>
                      <span className="sec-colr">{data?.email}</span>
                    </span>
                    <span className="width30 flex-sec">
                      <span
                        onClick={() =>
                          handlePatToChart(data?.userId, 'profile')
                        }
                        className="width100"
                      >
                        <Link
                          // to={`${DEFAULT_LOCAL_PATH}/patient/profile/${data?.userId}`}
                          className="width100"
                        >
                          Profile
                        </Link>
                      </span>
                      <span className="red hide">{' | '}</span>
                      <Link className="width100 clear-left10 hide">Text</Link>
                    </span>
                  </span>
                  <span className="width100 flex-sec">
                    <span className="width70">
                      <span className="sec-colr">
                        Payor:{data?.payor || 'N/A'} [ID:
                        {data?.insPolicyId || 'N/A'}]
                      </span>
                    </span>
                    <span className="width30 flex-sec">
                      <span
                        onClick={() =>
                          handlePatToChart(data?.userId, 'insurance')
                        }
                        className="width100"
                      >
                        <Link
                          className="width100"
                          // to={`${DEFAULT_LOCAL_PATH}/patient/insurance/${data?.userId}`}
                        >
                          Insurance
                        </Link>
                      </span>
                      <span className="red hide">{' | '}</span>
                      <Link className="width100 clear-left10 hide">
                        Payment Hx
                      </Link>
                    </span>
                  </span>
                </li>
              );
            })
          ) : (
            <div
              style={{
                height: '270px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                border: '5px dashed #e8e8e8',
                margin: '15px 0',
              }}
            >
              <span
                style={{ fontSize: '3rem', opacity: '0.2', fontWeight: 'bold' }}
              >
                No Patient Found
              </span>
            </div>
          )}
        </ul>
      </div>
    </div>
  );
}

export default PatientMainSerch;
